<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>Hybrid Solar System</h2>

            <ul>
                <li>
                    <a routerLink="/">Home</a>
                </li>
                <li>Solar Solutions</li>
                <li>Hybrid Solar System</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<section class="services-details-area ptb-110">
    <div class="container">

        <div class="services-details-overview">

            <div class="services-details-image wow animate__animated animate__fadeInUp">
                <img src="assets/image/hybrid-2.png" alt="Hybrid Solar System">
            </div>

            <div class="services-details-desc">

                <span>Hybrid Solar Solutions</span>

                <h3>Smart Solar Power with Grid Connection & Battery Backup</h3>

                <p>
                    A hybrid solar system combines solar panels, battery
                    storage, and grid connectivity to help you use solar
                    energy efficiently while keeping backup power available
                    when required.
                </p>

                <p>
                    Solar energy can be used to power your loads, excess
                    generation can be stored in batteries, and the grid can
                    provide additional power when solar generation or stored
                    energy is insufficient.
                </p>

                <ul class="features-list">

                    <li>
                        <i class="bx bx-check-double"></i>
                        Solar Power Generation
                    </li>

                    <li>
                        <i class="bx bx-check-double"></i>
                        Battery Backup
                    </li>

                    <li>
                        <i class="bx bx-check-double"></i>
                        Grid Connectivity
                    </li>

                    <li>
                        <i class="bx bx-check-double"></i>
                        Intelligent Energy Management
                    </li>

                </ul>

            </div>

        </div>

    </div>
</section>

<!-- What Is an Off-Grid Solar System? -->
<section class="features-area ptb-110 bg-f7f9fc">
    <div class="container">
        <div class="section-title">
            <span>Understanding Hybrid Solar</span>
            <h2>What Is a Hybrid Solar System?</h2>
            <p>
                A hybrid solar system combines solar generation, battery
                storage, and grid power to provide a flexible and reliable
                energy solution for homes and businesses.
            </p>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="solar-info-card">
                    <div class="solar-card-icon">
                        <i class="bx bx-sun"></i>
                    </div>
                    <span class="card-number">01</span>
                    <h3>Generate Solar Power</h3>
                    <p>
                        Solar panels generate electricity during available
                        sunlight and help meet your daily energy requirements.
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="solar-info-card">
                    <div class="solar-card-icon">
                        <i class="bx bx-battery"></i>
                    </div>
                    <span class="card-number">02</span>
                    <h3>Store Excess Energy</h3>
                    <p>
                        Excess solar generation can be stored in batteries
                        and used later when solar production is lower.
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="solar-info-card">
                    <div class="solar-card-icon">
                        <i class="bx bx-transfer"></i>
                    </div>
                    <span class="card-number">03</span>
                    <h3>Manage Energy Intelligently</h3>
                    <p>
                        The system can manage solar, battery, and grid power
                        according to energy availability and system settings.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- System Components -->
<section class="solar-components-area ptb-110 bg-fafafa">
    <div class="container">
        <div class="section-title">
            <span>System Components</span>
            <h2>What Makes a Hybrid Solar System?</h2>
            <p>
                A hybrid system brings together solar generation, energy
                storage, grid connectivity, and intelligent power management.
            </p>
        </div>

        <div class="solar-components-list">
            <div class="solar-component-item">
                <div class="component-number">01</div>
                <div class="component-icon">
                    <i class="bx bx-sun"></i>
                </div>
                <div class="component-content">
                    <h3>Solar Panels</h3>
                    <p>
                        Generate clean electricity from sunlight to power
                        connected loads and charge the battery.
                    </p>
                </div>
            </div>

            <div class="solar-component-item">
                <div class="component-number">02</div>
                <div class="component-icon">
                    <i class="bx bx-transfer"></i>
                </div>
                <div class="component-content">
                    <h3>Hybrid Inverter</h3>
                    <p>
                        Coordinates solar generation, battery storage,
                        household loads, and grid power.
                    </p>
                </div>
            </div>

            <div class="solar-component-item">
                <div class="component-number">03</div>
                <div class="component-icon">
                    <i class="bx bx-battery"></i>
                </div>
                <div class="component-content">
                    <h3>Battery Storage</h3>
                    <p>
                        Stores available solar energy for use during
                        nighttime or periods of lower solar generation.
                    </p>
                </div>
            </div>

            <div class="solar-component-item">
                <div class="component-number">04</div>
                <div class="component-icon">
                    <i class="bx bx-grid-alt"></i>
                </div>
                <div class="component-content">
                    <h3>Grid Connection</h3>
                    <p>
                        Provides an additional source of electricity when
                        solar and stored energy are not sufficient.
                    </p>
                </div>
            </div>
            <div class="solar-component-item">
                <div class="component-number">05</div>
                <div class="component-icon">
                    <i class="bx bx-cog"></i>
                </div>
                <div class="component-content">
                    <h3>Energy Management</h3>
                    <p>
                        Helps manage the flow of electricity between solar,
                        battery, grid, and connected loads.
                    </p>
                </div>
            </div>

            <div class="solar-component-item">
                <div class="component-number">06</div>
                <div class="component-icon">
                    <i class="bx bx-shield-quarter"></i>
                </div>
                <div class="component-content">
                    <h3>Safety & Accessories</h3>
                    <p>
                        Protection devices, cables, connectors, earthing,
                        and other accessories support safe system operation.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Ideal Applications -->
<section class="features-area ptb-110">
    <div class="container">
        <div class="section-title">
            <span>Ideal Applications</span>
            <h2>Where Does Hybrid Solar Make Sense?</h2>
            <p>
                Hybrid solar can be a practical choice for properties that
                want to combine solar savings with battery storage and
                grid availability.
            </p>
        </div>

        <div class="row">
            <div class="col-lg-3 col-md-6">
                <div class="single-featured-solutions">
                    <div class="features-icon">
                        <i class="bx bx-home"></i>
                    </div>
                    <h3>Homes</h3>
                    <p>
                        Use solar power during the day and stored energy
                        when required, with grid power available as an
                        additional source.
                    </p>
                </div>
            </div>

           <div class="col-lg-3 col-md-6">
                <div class="single-featured-solutions">
                    <div class="features-icon">
                        <i class="bx bx-buildings"></i>
                    </div>
                    <h3>Businesses</h3>
                    <p>
                        Help manage daytime energy consumption while
                        maintaining additional power flexibility.
                    </p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="single-featured-solutions">
                    <div class="features-icon">
                        <i class="bx bx-bolt-circle"></i>
                    </div>
                    <h3>Backup Requirements</h3>
                    <p>
                        Battery storage can help support selected loads
                        when grid power is unavailable, subject to system design.
                    </p>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-featured-solutions">
                   <div class="features-icon">
                        <i class="bx bx-line-chart"></i>
                    </div>
                    <h3>Energy Optimization</h3>
                    <p>
                        Suitable for users looking to better manage solar
                        generation, stored energy, and grid electricity.
                    </p>
               </div>
            </div>
        </div>
    </div>
</section>

<!-- Energy Storage -->
<section class="battery-storage-area ptb-110">
    <div class="container">
        <div class="battery-storage-box">
            <!-- Left Content -->
            <div class="battery-content">
                <span class="section-tag">
                    Energy Storage
                </span>
                <h2>
                    Battery Backup Is at the Heart of an Off-Grid System
                </h2>
                <p>
                    Since an off-grid system cannot rely on the utility grid,
                    battery storage plays an important role in maintaining
                    power when solar generation is unavailable.
                </p>
                <p>
                    The required battery capacity depends on your electricity
                    consumption, backup duration, load pattern, solar generation,
                    battery technology, and overall system design.
                </p>
                <a routerLink="/contact" class="btn btn-primary">
                    Discuss Your Energy Needs
                    <i class="flaticon-right"></i>
                </a>
            </div>


            <!-- Right Storage Features -->
            <div class="battery-features">
                <div class="battery-feature">
                    <div class="battery-feature-icon">
                        <i class="bx bx-home"></i>
                    </div>
                    <div>
                        <h3>Backup Designed Around Your Load</h3>
                        <p>
                            Battery capacity is planned according to your
                            actual electricity requirements.
                        </p>
                    </div>
                </div>


                <div class="battery-feature">
                    <div class="battery-feature-icon">
                        <i class="bx bx-sun"></i>
                    </div>
                    <div>
                        <h3>Day & Night Energy Management</h3>
                        <p>
                            Store excess solar energy during the day and
                            use it when solar generation is unavailable.
                        </p>
                    </div>
                </div>
                <div class="battery-feature">
                    <div class="battery-feature-icon">
                        <i class="bx bx-slider-alt"></i>
                    </div>
                    <div>
                        <h3>Customized Battery Capacity</h3>
                        <p>
                            Storage capacity can be selected based on
                            backup duration and energy consumption.
                        </p>
                    </div>
                </div>
                <div class="battery-feature">
                    <div class="battery-feature-icon">
                        <i class="bx bx-bolt-circle"></i>
                    </div>
                    <div>
                        <h3>Reliable Stored Energy</h3>
                        <p>
                            Keep essential loads powered during periods
                            of low or unavailable solar generation.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Why Choose Off-Grid Solar -->
<section class="services-area ptb-110 bg-fafafa">
    <div class="container">
        <div class="section-title">
            <span>Why Choose Hybrid Solar?</span>
            <h2>Flexibility, Solar Savings & Backup in One System</h2>
            <p>
                Hybrid solar brings together the advantages of solar
                generation, battery storage, and grid connectivity.
            </p>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="features-icon">
                        <i class="bx bx-sun"></i>
                    </div>
                    <h3>Use More Solar Energy</h3>
                    <p>
                        Solar electricity can be used directly to meet
                        your energy requirements during the day.
                    </p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="features-icon">
                        <i class="bx bx-battery"></i>
                    </div>
                    <h3>Battery Backup</h3>
                    <p>
                        Store available solar energy and use it later
                        when required, depending on system configuration.
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="features-icon">
                        <i class="bx bx-grid-alt"></i>
                    </div>
                    <h3>Grid Support</h3>
                    <p>
                        Grid electricity remains available as an additional
                        source when solar and battery power are insufficient.
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="features-icon">
                        <i class="bx bx-bolt-circle"></i>
                    </div>
                    <h3>Backup Capability</h3>
                    <p>
                        Selected loads can receive battery backup during
                        grid interruptions when supported by the system design.
                    </p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="features-icon">
                        <i class="bx bx-cog"></i>
                    </div>
                    <h3>Flexible Energy Management</h3>
                    <p>
                        Solar, battery, and grid sources can work together
                        to manage energy according to your requirements.
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="features-icon">
                        <i class="bx bx-leaf"></i>
                    </div>
                    <h3>Clean Energy</h3>
                    <p>
                        Increase the use of renewable solar energy and
                        reduce dependence on conventional electricity.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="solar-process-area ptb-110 bg-f7f9fc">
    <div class="container">

        <div class="section-title">
            <span>Our Process</span>

            <h2>From Requirement to Reliable Solar Power</h2>

            <p>
                <strong>SolarCiti</strong> follows a structured approach to understand your
                energy needs, design the right system, and deliver dependable
                solar power.
            </p>
        </div>

        <div class="solar-process">

            <!-- Step 01 -->
            <div class="process-step">

                <div class="process-top">
                    <span>01</span>
                    <i class="bx bx-map-pin"></i>
                </div>

                <div class="process-content">
                    <h3>Site Assessment</h3>

                    <p>
                        We understand your location, available space,
                        electricity usage, and energy requirements.
                    </p>
                </div>

            </div>


            <!-- Step 02 -->
            <div class="process-step">

                <div class="process-top">
                    <span>02</span>
                    <i class="bx bx-ruler"></i>
                </div>

                <div class="process-content">
                    <h3>System Sizing</h3>

                    <p>
                        Solar generation, inverter capacity, and battery
                        storage are planned around your requirements.
                    </p>
                </div>

            </div>


            <!-- Step 03 -->
            <div class="process-step">

                <div class="process-top">
                    <span>03</span>
                    <i class="bx bx-cog"></i>
                </div>

                <div class="process-content">
                    <h3>Installation</h3>

                    <p>
                        The selected solar equipment is installed and
                        configured for safe and efficient operation.
                    </p>
                </div>

            </div>


            <!-- Step 04 -->
            <div class="process-step">

                <div class="process-top">
                    <span>04</span>
                    <i class="bx bx-support"></i>
                </div>

                <div class="process-content">
                    <h3>Support</h3>

                    <p>
                        We provide post-installation support and maintenance
                        to help keep your solar system performing efficiently.
                    </p>
                </div>

            </div>

        </div>

    </div>
</section>

<!-- Start Services Details Area -->
<section class="services-details-area ">
    <div class="container">

        <!-- On Grid vs Off Grid -->
        <div class="services-details-comparison ptb-100">

            <div class="section-title">
                <span>Solar System Comparison</span>
                <h2>Off-Grid vs On-Grid Solar System</h2>
                <p>
                    Understanding the difference between on-grid and off-grid
                    systems can help you choose a solution that matches your
                    energy requirements.
                </p>
            </div>
            <div class="solar-comparison-wrapper">
                <div class="table-responsive">
                    <table class="solar-comparison-table">
                        <thead>
                            <tr>
                                <th>Feature</th>
                                <th>
                                    <span class="solar-type on-grid">
                                        On-Grid Solar
                                    </span>
                                </th>
                                <th>
                                    <span class="solar-type off-grid">
                                        Off-Grid Solar
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <strong>Grid Connection</strong>
                                </td>

                                <td>
                                    Connected to the electricity grid
                                </td>

                                <td class="highlight">
                                    Standalone system without grid dependence
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Battery Storage</strong>
                                </td>

                                <td>
                                    Generally not required
                                </td>

                                <td class="highlight">
                                    Essential for energy storage
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Backup During Grid Outage</strong>
                                </td>

                                <td>
                                    Generally unavailable
                                </td>

                                <td class="highlight">
                                    Battery can provide stored power
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Best Suited For</strong>
                                </td>

                                <td>
                                    Areas with reliable grid supply
                                </td>

                                <td class="highlight">
                                    Areas with unavailable or unreliable grid supply
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Energy Independence</strong>
                                </td>

                                <td>
                                    <span class="status-badge neutral">
                                        Lower
                                    </span>
                                </td>

                                <td class="highlight">
                                    <span class="status-badge positive">
                                        Higher
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services Details Area -->

<app-faq></app-faq>